export default {"src":"/_next/static/media/ic-upload-pack.365fe218.svg","height":11,"width":17,"blurWidth":0,"blurHeight":0};